// Behaviour of the add-to-cart popover (snippets/cart-notification.liquid).
// Loaded by the layout on every page. Targets exclusively the contractual
// data-cn-* hooks (contracts/snippets/cart-notification.md) and poses the `is-open`
// state class — a per-store fork of the popover markup inherits this
// behaviour untouched.
(function () {
  const notif = document.querySelector('[data-cart-notification]');
  if (!notif) return;

  const panel = notif.querySelector('[data-cn-panel]');
  const imgEl = notif.querySelector('[data-cn-image]');
  const titleEl = notif.querySelector('[data-cn-title]');
  const variantEl = notif.querySelector('[data-cn-variant]');
  const viewEl = notif.querySelector('[data-cn-view]');
  const viewLabel = viewEl.textContent.trim();

  function open() {
    notif.hidden = false;
    requestAnimationFrame(() => notif.classList.add('is-open'));
    panel.focus();
  }
  function close() {
    notif.classList.remove('is-open');
  }
  panel.addEventListener('transitionend', () => {
    if (!notif.classList.contains('is-open')) notif.hidden = true;
  });

  notif.querySelectorAll('[data-cn-close]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  document.addEventListener('click', (e) => {
    if (!notif.classList.contains('is-open')) return;
    if (panel.contains(e.target)) return;
    if (e.target.closest('form[action$="/cart/add"]')) return;
    close();
  });

  // Pubsub du thème : les badges (header, drawer) s'abonnent et se mettent
  // à jour eux-mêmes (assets/header.js).
  function publish(count) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: count } }));
  }

  function resize(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  async function addToCart(form) {
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) { form.submit(); return; }
      const item = await res.json();
      const cart = await (await fetch('/cart.js')).json();

      const src = (item.featured_image && item.featured_image.url) || item.image;
      if (src) { imgEl.src = resize(src, 160); imgEl.hidden = false; } else { imgEl.hidden = true; }
      titleEl.textContent = item.product_title || item.title;
      const vt = item.variant_title;
      variantEl.textContent = vt && vt !== 'Default Title' ? vt : '';
      viewEl.textContent = viewLabel + ' (' + cart.item_count + ')';
      publish(cart.item_count);
      open();
    } catch (e) {
      form.submit();
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });
})();
